
if(window.innerWidth <= 700) {
    $(window).scroll(function(){
        if ($(window).scrollTop() > 30) {
            $("#js-site-footer-navbar").fadeIn();
        }
        else { 
            $("#js-site-footer-navbar ").fadeOut();
        }
    });
}